const booksCollection = [
    { name: 'Anna Karenina', author: 'Leo Tolstoy' },
    { name: 'Madame Bovary', author: 'Gustave Flaubert' },
    { name: 'War and Peace', author: 'Leo Tolstoy' },
    { name: 'The Great Gatsby', author: 'F. Scott Fitzgerald' },
    { name: 'Middlemarch', author: 'George Eliot' },
    { name: 'The Paris Library', author: 'Janet Skeslien Charles' },
]

export default booksCollection;